export const GET_RENTAL= 'app/Rental/GET_RENTAL';
